import { FooterSect, Text } from "./Footer";
import { Container } from "../Container/Container.jsx";

export const Footer = () => {
  return (
    <FooterSect>
      <Container>
        <Text>Thank for giving your informations :)</Text>
      </Container>
    </FooterSect>
  );
};
